import { createFileRoute } from "@tanstack/react-router";
import { routeMeta } from "@/lib/route-meta";
import AdminSecurityAlerts from "@/pages/AdminSecurityAlerts";

export const Route = createFileRoute("/admin/security-alerts")({ head: () => routeMeta('Security Alerts | MNRE Admin', 'Review access and security alerts for MNRE operations.', '/admin/security-alerts'), component: AdminSecurityAlerts });
